// src/components/DropBoxUploader.jsx  ← FINAL WORKING VERSION
import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Box, Button, Typography, CircularProgress, Alert } from '@mui/material';
import { CloudUpload, Delete } from '@mui/icons-material';
import axios from 'axios';

const DropBoxUploader = ({
  installation = 'unknown',
  siteid = 'form_bg',
  value = '',
  onChange = () => {},
  disabled = false,
}) => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const onDrop = useCallback(async (acceptedFiles) => {
    if (acceptedFiles.length === 0) return;

    const file = acceptedFiles[0];
    setUploading(true);
    setError('');

    // Clean filename
    const fileid = file.name
      .replace(/#/g, '')
      .replace(/\s+/g, '_')
      .replace(/[^a-zA-Z0-9._-]/g, '');

    const formData = new FormData();
    formData.append('data', file);
    formData.append('action', 'put-newserver-file');
    formData.append('fileid', fileid);
    formData.append('siteid', siteid);

    try {
      const response = await axios.post(
        'https://gotoreconfiles.com/cors_new_server.php',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      );

      const url = response.data.trim(); // ← Important: trim any whitespace
      onChange(url);
    } catch (err) {
      console.error('Upload failed:', err);
      setError('Upload failed. Please try again.');
    } finally {
      setUploading(false);
    }
  }, [siteid, onChange]);

  // This works on ALL versions of react-dropzone
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: 'image/*', // ← String format = works everywhere
    multiple: false,
    disabled: uploading || disabled,
  });

  const handleRemove = () => {
    onChange('');
  };

  return (
    <Box>
      {/* Current Image */}
      {value ? (
        <Box sx={{ mb: 2, textAlign: 'center' }}>
          <img
            src={value}
            alt="Uploaded"
            style={{
              maxWidth: '100%',
              maxHeight: 180,
              borderRadius: 8,
              border: '1px solid #ddd',
              objectFit: 'cover',
            }}
          />
          <Button
            size="small"
            color="error"
            startIcon={<Delete />}
            onClick={handleRemove}
            sx={{ mt: 1 }}
          >
            Remove
          </Button>
        </Box>
      ) : (
        <Box
          {...getRootProps()}
          sx={{
            border: '2px dashed #ccc',
            borderRadius: 2,
            p: 4,
            textAlign: 'center',
            cursor: 'pointer',
            bgcolor: isDragActive ? '#f0f8ff' : '#fafafa',
            transition: 'all 0.2s',
            '&:hover': { borderColor: '#999' },
          }}
        >
          <input {...getInputProps()} />
          <CloudUpload sx={{ fontSize: 48, color: '#999', mb: 1 }} />
          <Typography variant="body2" color="text.secondary">
            {isDragActive
              ? 'Drop the image here...'
              : 'Drag & drop an image, or click to select'}
          </Typography>
        </Box>
      )}

      {uploading && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2, justifyContent: 'center' }}>
          <CircularProgress size={20} />
          <Typography variant="body2">Uploading...</Typography>
        </Box>
      )}

      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}
    </Box>
  );
};

export default DropBoxUploader;